<template>
  <div :class="$style['size-selector']">
    <Btn
      shape="round"
      size="small"
      :color="cardSize === 'small' ? '' : 'white'"
      icon-only="Design/layout-grid-2-line"
      aria-label="Small grid"
      @click="cardSize = 'small'" />
    <Btn
      shape="round"
      size="small"
      :color="cardSize === 'medium' ? '' : 'white'"
      icon-only="Design/layout-grid-line"
      aria-label="Medium grid"
      @click="cardSize = 'medium'" />
    <Btn
      shape="round"
      size="small"
      :color="cardSize === 'large' ? '' : 'white'"
      icon-only="Design/square-line"
      aria-label="Large grid"
      @click="cardSize = 'large'" />
  </div>
</template>

<script setup>
const expireDate = new Date()
expireDate.setFullYear(expireDate.getFullYear() + 2)
const cardSize = useCookie('cardSize', {
  expires: expireDate
})

</script>

<style lang="scss" module>

.size-selector {
    display: flex;
    gap: var(--spacing);
    justify-content: flex-end;
    margin-block-end: var(--spacing);
    margin-inline-end: calc(var(--spacing ) * 2);

    @media (width <= 468px) {
      > :first-child {
        display: none;
      }
    }
  }
</style>
